import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class OnboardingLoginStepTwoError extends BaseEitherError {}

export type TOnboardingLoginStepTwoOperationErrors = OnboardingLoginStepTwoError;
